import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { Llibrets } from '../../Components/Historico/LlibretsComponent';
import { Footer } from '../../Components/Footer/FooterComponent';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';

export const Llibret = (props) => {
    return(
        <>
            <LogoHeader I18n={props.I18n}/>
            <NavDesktop I18n={props.I18n}/>
            <NavMobile I18n={props.I18n}/>
            <Llibrets I18n={props.I18n} Data={props.Data}/>
            <Footer I18n={props.I18n}/>
        </>
    );
}